import React, { useContext, useEffect, useRef, useState } from 'react';
import Api, { apiEventEmitter, initApis } from '../../api/Api';
import { StoreContext } from '../../store/store';
import { MenuListItem, PageID } from '../../typings/menu';
import styles from './Style/Home.module.scss';
import { Button, Layout, Modal } from 'antd';
import SearchPop from './Component/Search/SearchPop';
import ShoppingCart from './Component/ShoppingCart/ShoppingCart';
import UserProfile from './Component/UserProfile/UserProfile';
import { useLocation, Link, useHistory, useRouteMatch } from 'react-router-dom';
import { Content } from 'antd/lib/layout/layout';
import { INotificationResponse } from '../../mock/Notifications';
import { isEmpty } from 'underscore';
import Header from '../header/Header';
import PricingModal from '../Pages/Dialogue/PricingModal/PricingModal';
import ContactModal from '../Pages/Dialogue/ContactModal/ContactModal';
import FeaturesModal from '../Pages/Dialogue/FeaturesModal/FeaturesModal';
import MaintenanceBanner from './Component/MaintenanceBanner';
import AdvertisingBanner from './Component/AdvertisingBanner';
import LoadModal from '../../components/Loading/LoadModal';
import { withLoading } from '../../components/Loading/withLoading';
import LoadingContext from '../../context/loadingContext/LoadingContext';
import InvitationModal from '../User/Invtiation/InvitationModal';
import AuthenticateModal from '../User/Login/AuthenticateModal';
import AssociateWithCompanyModal from '../User/Login/AssociateWithCompanyModal';
import SubscriptionExpiredModal from './Component/Subscription/SubscriptionExpiredModal';
import NotificationModal from '../Pages/Dialogue/NotificationModal/NotificationModal';
import { SEARCHPARAM } from './Component/Main/MainMap';
import DownloadApiModal from '../Pages/Dialogue/DownloadApiModal/DownloadApiModal';
import { useSelectedDataset } from '../header/components/SearchBar';

export interface AuditCompareRouteParams {
  activateCode: string;
}

interface IProps {
  children: React.ReactNode;
}

export default function Home(props: IProps) {
  const context = useContext(StoreContext);
  const loadingContext = useContext(LoadingContext);
  const [, setPageId] = useState<PageID | undefined>('app');
  const [selectMenuKey, setSelectMenuKey] = useState<string[]>([]);
  const [isActivateModalVisible, setIsActivateModalVisible] = useState(false);
  const [activateMessage, setActivateMessage] = useState('');
  const { onChange } = useSelectedDataset((id) => context.setSearchId(id))

  const history = useHistory();
  const location = useLocation();
  const effectRan = useRef(false);


  const pageIdsToNotCollapseMenu = ['app', 'contact', 'pricing'];


  const isPaymentSuccessRoute = useRouteMatch({
    path: '/paymentsuccess',
    strict: true,
    sensitive: true,
  });

  // First Load open url modal
  const pathName = useLocation().pathname.substring(1);
  useEffect(() => {
    const splitPath = pathName.split('/');
    const pageId = splitPath[0].toLocaleLowerCase() as PageID;
    if (pageId === 'metadata' && isEmpty(splitPath[1])) {
      if (!isEmpty(splitPath[1])) {
        context.setSearchId(splitPath[1]);
      }
      context.setShowSearch(true);
    }
    if (pageId === 'metadata' && !isEmpty(splitPath[1])) {
      context.setSearchId(splitPath[1]);
      context.setShowSearch(true);
    }
    if (pageId === 'pricing') {
      context.setShowPricingModal(true);
    }
    if (pageId === 'features') {
      context.setShowFeaturesModal(true);
    }
    if (pageId === 'contact') {
      context.setShowContactModal(true);
    }
    if (pageId === 'notifications') {
      context.setShowNotifications(true);
    }
    if (pageId === 'api'){
      context.setShowDownloadApiModal(true)
    }
  }, []);

  // On page change open or close url modal
  useEffect(() => {
    return history.listen((location) => {
      const pageId = location.pathname.split('/')[1];
      setPageId(pageId as PageID);
      if (location.pathname === '/' || pageId === '') {
        context.setShowPricingModal(false);
        context.setShowSearch(false);
        context.setShowContactModal(false);
        context.setShowFeaturesModal(false);
        context.setShowGetStartedModal(false);
        context.setShowNotifications(false);
        context.setShowDownloadApiModal(false)
        return;
      }

      const splitPath = pathName.split('/');
      if (pageId === 'metadata' && isEmpty(splitPath[1])) {
        if (!isEmpty(splitPath[1])) {
          context.setSearchId(splitPath[1]);
        }
        context.setShowSearch(true);

        context.setShowPricingModal(false);
        context.setShowContactModal(false);
        context.setShowFeaturesModal(false);
        context.setShowDownloadApiModal(false);
        context.setShowGetStartedModal(false);
        context.setShowNotifications(false);
        return;
      }
      if (pageId === 'metadata' && !isEmpty(splitPath[1])) {
        context.setSearchId(splitPath[1]);
        context.setShowSearch(true);

        context.setShowDownloadApiModal(false);
        context.setShowPricingModal(false);
        context.setShowContactModal(false);
        context.setShowFeaturesModal(false);
        context.setShowGetStartedModal(false);
        context.setShowNotifications(false);
        return;
      }

      if (pageId === 'pricing') {
        context.setShowPricingModal(true);

        context.setShowSearch(false);
        context.setShowDownloadApiModal(false);
        context.setShowContactModal(false);
        context.setShowFeaturesModal(false);
        context.setShowGetStartedModal(false);
        context.setShowNotifications(false);
        return;
      }
      if (pageId === 'features') {
        context.setShowFeaturesModal(true);

        context.setShowPricingModal(false);
        context.setShowSearch(false);
        context.setShowContactModal(false);
        context.setShowGetStartedModal(false);
        context.setShowDownloadApiModal(false);
        context.setShowNotifications(false);
        return;
      }
      if (pageId === 'contact') {
        context.setShowContactModal(true);

        context.setShowPricingModal(false);
        context.setShowSearch(false);
        context.setShowFeaturesModal(false);
        context.setShowGetStartedModal(false);
        context.setShowDownloadApiModal(false);
        context.setShowNotifications(false);
        return;
      }
      if (pageId === 'getstarted') {
        context.setShowGetStartedModal(true);

        context.setShowPricingModal(false);
        context.setShowSearch(false);
        context.setShowFeaturesModal(false);
        context.setShowContactModal(false);
        context.setShowNotifications(false);
        context.setShowDownloadApiModal(false);
        return;
      }
      if (pageId === 'notifications'){
        context.setShowNotifications(true);

        context.setShowGetStartedModal(false);
        context.setShowPricingModal(false);
        context.setShowSearch(false);
        context.setShowFeaturesModal(false);
        context.setShowContactModal(false);
        context.setShowDownloadApiModal(false);

        return
      }
      if (pageId === 'api'){
        context.setShowDownloadApiModal(true);

        context.setShowGetStartedModal(false);
        context.setShowPricingModal(false);
        context.setShowSearch(false);
        context.setShowFeaturesModal(false);
        context.setShowContactModal(false);
        context.setShowNotifications(false);
        return
      }
    });
  }, [history]);

  function triggerMenuClick(item: any) {
    const key: string = item.key;
    let menu: MenuListItem | undefined = undefined;
    if (key.includes('-')) {
      const [index1, index2] = key.split('-').map((k) => Number(k) - 1);
      menu = context.menuList[index1].children[index2];
    } else {
      menu = context.menuList[+key - 1];
    }
    setSelectMenuKey([menu.id]);
    setPageId(menu!.pageId);
    if (menu.pageId && !pageIdsToNotCollapseMenu.includes(menu.pageId)) {
      context.setMenuCollapse(true);
    }
    if (menu.pageId && menu.pageId !== 'app') {
      context.setShowLayerView(false);
    }
  }

  useEffect(() => {
    // get country select options
    async function getOptions() {
      await initApis();
      const notifications = await Api.notifications.getNotifications(); //Notifications; //
      context.setNotifications(
        notifications.map((notification: INotificationResponse) => {
          return {
            ...notification,
            id: notification.guid,
            time: new Date(notification.datetime).getTime(),
            hasLink: notification.link ? true : false,
            message: notification.text,
          };
        })
      );
    }
    async function getInfofromBsApi() {
      context.setLoadingDataFromBSApi(true)
      await initApis();
      const companySizeData = await Api.bsApi.getCompanySizeInfo();
      context.setCompanySizeList(companySizeData);
      const segmentsData = await Api.bsApi.getSegmentsInfo();
      context.setSegmentsList(segmentsData);
      const countryData = await Api.bsApi.getPriceCountryList();
      context.setCountryList(countryData);
      context.setLoadingDataFromBSApi(false)
    }
    withLoading(getOptions, loadingContext, {
      source: 'getOptions',
    });
    const searchParams = new URLSearchParams(location.search);
    const coordinate = searchParams.get(SEARCHPARAM.COOR);

    if(!coordinate){
      context.setAddingPointToMap(true)
    }
    getInfofromBsApi();
  }, []);

  useEffect(() => {
    // We need to await the trial to signin silently
    // Else the backend is called twice
    if (isEmpty(context.user)) {
      return;
    }

    // Prepare dataset briefs
    // We need to repeat the call when user changes as returned dataset briefs are user spcific
    // ids are input for GetAllMoodSpacedefinition call that returns the dataset extent polygons shown on the map
    // Some datasets are confidential and need to be hidden for users without view rights
    const getDatasetBriefs = async () => {
      await initApis();
      const datasetBriefs = await Api.search.dataSetBriefs({
        includeGlobal: false,
      });

      if (context.user.authenticated){
        const fweDatasetBriefs = await Api.search.dataSetBriefs({
        includeGlobal: false,
        vas: 'fwe'
        });
        context.setDatasetBrief(datasetBriefs.concat(fweDatasetBriefs));
        context.setFWEDatasetBrief(fweDatasetBriefs);
      }
      else{
        context.setDatasetBrief(datasetBriefs)
        context.setFWEDatasetBrief([]);
      }
    };

    withLoading(getDatasetBriefs, loadingContext, {
      source: 'getDatasetBriefs',
    });

    async function fetchAntiForgeryToken(){
      await Api.auth.getAntiForgeryToken()
    }

    fetchAntiForgeryToken()

  }, [context.user]);

  function onCloseCart() {
    context.setShowCart(false);
  }

  function goCheckoutPage() {
    onCloseCart();
    setSelectMenuKey([]);
    setPageId('checkout');
    context.setMenuCollapse(false);
    history.push('checkout');
  }

  function onCloseUserProfile() {
    context.setShowUserProfile(false);
  }

  function onCloseActivateMessage() {
    setIsActivateModalVisible(false);
    setActivateMessage('');
  }

  const handleCloseAllModals = () => {
    context.setShowPricingModal(false);
    context.setShowSearch(false);
    context.setShowContactModal(false);
    context.setShowFeaturesModal(false);
    context.setShowGetStartedModal(false);
    context.setShowDownloadApiModal(false);
  };

  const handleLogin = React.useCallback(() => {
    (window.top || window).location.assign(
      `${Api.SERVER_DOMAIN}${Api.IISSite}/auth/signin`
    );
  }, []);

  useEffect(() => {
    const handleError = () => {
      if(!isEmpty(context.user)){
        Modal.confirm({
          title: 'Session Expired',
          content: (
            <div>
              <p>Your session was terminated automatically because we have detected a lack of activity.</p>
              <p>If you wish to continue with metocean-on-demand please sign in again.</p>
            </div>
          ),
          okText: 'Sign In',
          onOk: handleLogin,
          okButtonProps: { style: { margin: '0 auto', display: 'flex', justifyContent: 'center' } },
          cancelButtonProps: { style: { display: 'none' } },
          closable: true,
        });
      }
    };

    apiEventEmitter.on('credentialError', handleError);

    return () => {
      apiEventEmitter.off('credentialError', handleError);
    };
  }, [context.user]);

  useEffect(() => {
    if (effectRan.current) return;

    if (!isEmpty(context.searchId) && !isEmpty(context.datasetBriefs)) {
      onChange(context.searchId);
      effectRan.current = true;
    }
  }, [context.searchId, context.datasetBriefs]);

  return (
    <InvitationModal>
      <Layout className={styles.root}>
        <Header
          advertisingBannerClick={() => {
            if (context.showAdvertisingBanner === 'true') {
              context.setShowAdvertisingBanner('false');
            }
            if (context.showAdvertisingBanner === 'false') {
              context.setShowAdvertisingBanner('true');
            }
          }}
        ></Header>
        <Content>
          <PricingModal
            visible={context.showPricingModal}
            onHandlePricingModalCancel={() => history.push('/')}
            handleCloseAllModals={handleCloseAllModals}
          />
          <DownloadApiModal
            visible={context.showDownloadApiModal}
            onHandleDownloadApiModalCancel={() => history.push('/')}
          />
          <ContactModal
            visible={context.showContactModal}
            onHandleContactModalCancel={() => history.push('/')}
          />
          <FeaturesModal
            visible={context.showFeaturesModal}
            onHandleFeaturesModalCancel={() => history.push('/')}
            handleCloseAllModals={handleCloseAllModals}
          />
          <NotificationModal
            visible={context.showNotifications}
            onHandleNotificationModalCancel={() => history.push('/')}
          />
          <Modal
            visible={isActivateModalVisible}
            footer={
              <Link to={'/app'}>
                <Button onClick={onCloseActivateMessage}>Ok</Button>
              </Link>
            }
          >
            <p>{activateMessage}</p>
          </Modal>

          <Modal
            closable={false}
            keyboard={false}
            visible={isPaymentSuccessRoute !== null}
            title={'Checkout successful'}
            footer={
              <Link to={'/'}>
                <Button>OK</Button>
              </Link>
            }
          >
            {
              'An email with a link to download the data will be sent to you within a few minutes. You will be redirected to the main page.'
            }
          </Modal>
          {context.showAssociateToCompany.status && <AssociateWithCompanyModal />}
          {context.showSubscriptionExpiredModal.status && <SubscriptionExpiredModal />}
          {(context.showLogin || context.showSpectraModal) && <AuthenticateModal />}
          <SearchPop
            visible={context.showSearch}
            searchID={(id) => context.setSearchId(id)}
            onHandleDatasetsModalCancel={() => history.push('/')}
          />
          {/* <TourPop /> */}

          {/* {context.notifications.length > 0 && <NewsBanner />} */}
          <div className={styles.bannerContainer}>
            {context.notifications.length > 0 && <MaintenanceBanner />}
            {context.showAdvertisingBanner && <AdvertisingBanner />}
          </div>

          {/* {isMainAppRoute && mainMapMemo} */}

          {context.showCart && (
            <ShoppingCart close={onCloseCart} checkout={goCheckoutPage} />
          )}
          {context.showUserProfile && (
            <UserProfile close={onCloseUserProfile} user={context.user} />
          )}

          {props.children}
        </Content>
        <LoadModal />
      </Layout>
    </InvitationModal>
  );
}
